// extracted by mini-css-extract-plugin
export default {"count":"table_count__O8gMg","container":"table_container__JavVK","table":"table_table__2IQ7e","messageNotRegisters":"table_messageNotRegisters__-LtpG"};